import { z } from 'zod';

var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["IMAGE"] = "image";
  MediaType2["IMG"] = "img";
  MediaType2["AUDIO"] = "audio";
  MediaType2["VIDEO"] = "video";
  MediaType2["EMBED"] = "embed";
  MediaType2["PDF"] = "pdf";
  MediaType2["UKW"] = "";
  return MediaType2;
})(MediaType || {});
const audioSchema = z.object({
  type: z.literal("audio" /* AUDIO */),
  url: z.string()
});
const videoSchema = z.object({
  type: z.literal("video" /* VIDEO */),
  url: z.string().optional().nullable(),
  video: z.string().optional().nullable(),
  meta: z.object({
    startTime: z.number().optional().nullable(),
    endTime: z.number().optional().nullable(),
    videoId: z.string().optional().nullable(),
    duration: z.number().optional().nullable(),
    src: z.enum(["", "google-drive", "one-drive", "local"]).optional().nullable(),
    type: z.string().optional().nullable()
  }).optional().nullable()
});
const imageSchema = z.object({
  type: z.literal("image" /* IMAGE */),
  url: z.string(),
  meta: z.object({
    width: z.number().optional().nullable(),
    height: z.number().optional().nullable(),
    layout: z.string().optional().nullable(),
    googleSearch: z.boolean().optional().nullable(),
    text: z.string().optional().nullable()
  }).optional().nullable()
});
const imgSchema = imageSchema.extend({
  type: z.literal("img" /* IMG */)
});
const mediaSchema = z.discriminatedUnion("type", [
  imageSchema,
  audioSchema,
  videoSchema,
  imgSchema,
  z.object({
    type: z.literal("pdf" /* PDF */),
    url: z.string()
  })
]);

export { MediaType, audioSchema, imageSchema, mediaSchema, videoSchema };
